var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "toolbar",
        { attrs: { title: _vm.pageTitle, extended: _vm.isMobile } },
        [
          _c(
            "v-layout",
            {
              attrs: { slot: _vm.isMobile ? "extension" : null },
              slot: _vm.isMobile ? "extension" : null
            },
            [
              _c(
                "v-toolbar-items",
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "mr-4",
                      attrs: {
                        small: "",
                        fab: "",
                        color: "accent",
                        to: "/post-load"
                      }
                    },
                    [_c("v-icon", [_vm._v("add")])],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "toolbar-btn",
                      attrs: {
                        flat: "",
                        small: "",
                        right: "",
                        to: { name: "company.loads.recurring" }
                      }
                    },
                    [
                      _c(
                        "v-layout",
                        { staticClass: "align-center", attrs: { column: "" } },
                        [_c("v-icon", [_vm._v("sync")])],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "toolbar-btn",
                      attrs: {
                        flat: "",
                        small: "",
                        right: "",
                        to: { name: "company.loads.repeat" }
                      }
                    },
                    [
                      _c(
                        "v-layout",
                        { staticClass: "align-center", attrs: { column: "" } },
                        [_c("v-icon", [_vm._v("redo")])],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "toolbar-btn",
                      attrs: {
                        flat: "",
                        small: "",
                        right: "",
                        to: { name: "company.loads.dispatch_offers" }
                      }
                    },
                    [
                      _c(
                        "v-layout",
                        { staticClass: "align-center", attrs: { column: "" } },
                        [
                          _c("v-icon", [_vm._v("share")]),
                          _vm._v(" "),
                          _vm.loadingDispatchRequests
                            ? _c("v-progress-linear", {
                                staticClass: "mt-2 mb-0",
                                attrs: { color: "white", indeterminate: true }
                              })
                            : [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.dispatchRequestTrucks) +
                                    "\n            "
                                )
                              ]
                        ],
                        2
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.showSpaceTimeContinuum
                    ? _c(
                        "v-btn",
                        {
                          staticClass: "toolbar-btn",
                          attrs: {
                            flat: "",
                            small: "",
                            right: "",
                            to: { name: "company.loads.direct_dispatch" }
                          }
                        },
                        [
                          _c(
                            "v-layout",
                            {
                              staticClass: "align-center",
                              attrs: { column: "" }
                            },
                            [
                              _c("v-icon", [_vm._v("headset_mic")]),
                              _vm._v(" "),
                              _vm.loadingDispatchedDriverLoads
                                ? _c("v-progress-linear", {
                                    staticClass: "mt-2 mb-0",
                                    attrs: {
                                      color: "white",
                                      indeterminate: true
                                    }
                                  })
                                : [
                                    _c(
                                      "span",
                                      {
                                        class: {
                                          "yellow--text":
                                            _vm.dispatchedDriverPlanHoles > 0
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.dispatchedDriverPlanHoles
                                            ) +
                                            "\n              "
                                        )
                                      ]
                                    )
                                  ]
                            ],
                            2
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.hasPlannerPermission
                    ? _c(
                        "v-btn",
                        {
                          staticClass: "toolbar-btn",
                          attrs: {
                            flat: "",
                            small: "",
                            right: "",
                            to: { name: "company.loads.planner" }
                          }
                        },
                        [
                          _c(
                            "v-layout",
                            {
                              staticClass: "align-center",
                              attrs: { column: "" }
                            },
                            [
                              _c("v-icon", [_vm._v("chrome_reader_mode")]),
                              _vm._v(" "),
                              _vm.loadingPlannedLoads
                                ? _c("v-progress-linear", {
                                    staticClass: "mt-2 mb-0",
                                    attrs: {
                                      color: "white",
                                      indeterminate: true
                                    }
                                  })
                                : [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(_vm.plannedLoadGroupTrucks) +
                                        "\n            "
                                    )
                                  ]
                            ],
                            2
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "toolbar-btn",
                      attrs: {
                        flat: "",
                        small: "",
                        right: "",
                        to: { name: "company.loads.scheduled" }
                      }
                    },
                    [
                      _c(
                        "v-layout",
                        { staticClass: "align-center", attrs: { column: "" } },
                        [
                          _c("v-icon", [_vm._v("schedule")]),
                          _vm._v(" "),
                          _vm.loadingLoads
                            ? _c("v-progress-linear", {
                                staticClass: "mt-2 mb-0",
                                attrs: { color: "white", indeterminate: true }
                              })
                            : [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.scheduledLoads.length) +
                                    "\n            "
                                )
                              ]
                        ],
                        2
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "toolbar-btn",
                      attrs: {
                        flat: "",
                        small: "",
                        right: "",
                        to: { name: "company.loads.in_transit" }
                      }
                    },
                    [
                      _c(
                        "v-layout",
                        { staticClass: "align-center", attrs: { column: "" } },
                        [
                          _c("v-icon", [_vm._v("local_shipping")]),
                          _vm._v(" "),
                          _vm.loadingLoads
                            ? _c("v-progress-linear", {
                                staticClass: "mt-2 mb-0",
                                attrs: { color: "white", indeterminate: true }
                              })
                            : [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.inTransitLoads.length) +
                                    "\n            "
                                )
                              ]
                        ],
                        2
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "toolbar-btn",
                      attrs: {
                        flat: "",
                        small: "",
                        right: "",
                        to: { name: "company.loads.delivered" }
                      }
                    },
                    [
                      _c(
                        "v-layout",
                        { staticClass: "align-center", attrs: { column: "" } },
                        [
                          _c("v-icon", [_vm._v("done")]),
                          _vm._v(" "),
                          _vm.loadingLoads
                            ? _c("v-progress-linear", {
                                staticClass: "mt-2 mb-0",
                                attrs: { color: "white", indeterminate: true }
                              })
                            : [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.deliveredLoads.length) +
                                    "\n            "
                                )
                              ]
                        ],
                        2
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.hasHistoricalLoadsPermission
                    ? _c(
                        "v-btn",
                        {
                          staticClass: "toolbar-btn",
                          attrs: {
                            flat: "",
                            small: "",
                            right: "",
                            to: { name: "company.loads.history" }
                          }
                        },
                        [
                          _c(
                            "v-layout",
                            {
                              staticClass: "align-center",
                              attrs: { column: "" }
                            },
                            [_c("v-icon", [_vm._v("history")])],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.isMobile
        ? _c(
            "div",
            { staticClass: "pa-3" },
            [
              _c("v-text-field", {
                staticClass: "mb-2 single-line hide-details",
                attrs: { "append-icon": "search", label: "Search loads" },
                model: {
                  value: _vm.search,
                  callback: function($$v) {
                    _vm.search = $$v
                  },
                  expression: "search"
                }
              }),
              _vm._v(" "),
              _c("v-select", {
                staticClass: "mb-2",
                attrs: {
                  items: _vm.mobileSortOptions,
                  "menu-props": "auto",
                  label: "Sort by",
                  "hide-details": "",
                  "append-icon": "sort",
                  "single-line": ""
                },
                model: {
                  value: _vm.sortValue,
                  callback: function($$v) {
                    _vm.sortValue = $$v
                  },
                  expression: "sortValue"
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c("router-view", {
            attrs: { company: _vm.company },
            on: { updateLoad: _vm.onUpdateLoad }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7408585c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7408585c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Companies/Loads/LoadsPage.vue
// module id = null
// module chunks = 